module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/custom-grid-01-545c816cbc6655e71666c8c93b52bc38.jpg";